export default __webpack_public_path__ + "static/media/setting_1.2d600182.png";